<template>
  <header class="site-header" id="home__header">
    <nav class="skip-links">
      <ul>
        <li class="to-content"><a href="#conteudo">conteúdo</a></li>
        <li class="to-menu"><a href="#menu">menu</a></li>
      </ul>
    </nav>
    <nav class="main-menu">
      <div class="menu-container">
        <button class="mobile-button">
          <span></span>
          <span></span>
          <span></span>
        </button>
        <div class="brand-wrap">
          <a href="https://www.cirogomes.com.br/" class="logo-ciro">
            Virar o jogo com Ciro
          </a>
        </div>
        <ul class="menu-wrap">
          <li class="menu-item menu-item--knowMore">
            <a href="#home__knowMore" v-scroll-to="'#home__knowMore'">
              Conheça
            </a>
          </li>
          <li class="menu-item menu-item--goals">
            <a href="#home__goals" v-scroll-to="'#home__goals'">
              Metas
            </a>
          </li>
          <li class="menu-item menu-item--faq">
            <a href="#home__faq" v-scroll-to="'#home__faq'">
              Perguntas frequentes
            </a>
          </li>
          <li class="menu-item menu-item--donors">
            <a href="#home__donors" v-scroll-to="'#home__donors'">
              Doadores
            </a>
          </li>
          <li class="menu-item donate-nav">
            <a href="#doar" v-scroll-to="'#doar'">
              Doar
            </a>
          </li>
        </ul>
      </div>
    </nav>

    <div class="header-container">
      <div class="site-label">
        <h1>
          Vamos virar esse
          <span class="alt" role="text">
            jogo
              <span class="alt" role="text">!</span>
          </span>
        </h1>
      </div>
      <a class="call-to-action" href="#doar" v-scroll-to="'#doar'">
        &gt; quero doar
      </a>
      <button id="open-modal" @click="toggleModal()" class="play-button" v-if="youtubeVideoId">
        assista ao vídeo
      </button>
    </div>
    <template v-if="youtubeVideoId">
      <div class="modal-overlay closed" @click="toggleModal()" id="modal-overlay"></div>

      <div class="modal closed" id="modal">
        <button class="close-button" id="close-button" @click="toggleModal()">&times;</button>
          <div class="embed-container">
            <iframe width="560" height="315" :src="`https://www.youtube-nocookie.com/embed/${youtubeVideoId}?rel=0&amp;showinfo=0&enablejsapi=1`"
            frameborder="0" allow="autoplay; encrypted-media"
            allowfullscreen id="iframeYoutube"></iframe>
          </div>
      </div>
    </template>
  </header>
</template>

<script>
export default {
  name: 'Header',
  data() {
    return {
      youtubeVideoId: '1DKYZVnuDjc',
    };
  },
  methods: {
    toggleModal() {
      const modal = document.querySelector('#modal');
      const modalOverlay = document.querySelector('#modal-overlay');
      const iframeYoutube = document.querySelector('#iframeYoutube');
      const func = modal.className.indexOf('closed') === -1 ? 'pauseVideo' : 'playVideo';

      modal.classList.toggle('closed');
      modalOverlay.classList.toggle('closed');

      iframeYoutube.contentWindow.postMessage(`{"event":"command","func":"${func}","args":""}`, '*');
    },
    scrollMenu() {
      const element = document.querySelector('.main-menu');
      window.addEventListener('scroll', () => {
        const newOffset = window.scrollY;

        if (newOffset > 13 && window.matchMedia('').matches) {
          element.classList.add('animate');
        } else {
          element.classList.remove('animate');
        }
      });
    },
    showMenu() {
      const element = document.querySelector('.mobile-button');
      const menu = document.querySelector('.menu-wrap');
      const menuItems = document.querySelectorAll('.menu-wrap a');

      element.addEventListener('click', () => {
        menu.classList.toggle('show');
      });

      for (let i = 0; i < menuItems.length; i += 1) {
        const item = menuItems[i];
        item.addEventListener('click', () => {
          menu.classList.remove('show');
        });
      }
    },
  },
  created() {
    this.$nextTick(() => {
      this.scrollMenu();
      this.showMenu();
    });
  },
};
</script>

